import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { RatingsByVenueInsight } from 'apis/merchant-gateway/insights/ratings-by-venue/types';
import { InfiniteTable } from 'modules/experience-core';

import { RatingsByVenueTable } from './RatingsByVenueTable';
import { RatingsByVenueTableSortableColumnIDs, useRatingsByVenueTableProps } from './hooks/useRatingsByVenueTableProps';
import { ContentRow, InsightResponsePaginated, RowType } from '../../types';
import SummaryTable from '../InsightSummary/SummaryTable';

export const RatingsByVenueCard = ({
  ratingsByVenueInsights,
  sort,
  setSort,
}: {
  ratingsByVenueInsights: InsightResponsePaginated<RatingsByVenueInsight>;
  sort: InfiniteTable.SortState<RatingsByVenueTableSortableColumnIDs>;
  setSort: (sort: InfiniteTable.SortState<RatingsByVenueTableSortableColumnIDs>) => void;
}) => {
  const intl = useIntl();

  const tableProps = useRatingsByVenueTableProps({
    sort,
    setSort,
    ratingsByVenueInsights,
  });

  const rows: ContentRow[] = useMemo(
    () => [
      {
        type: RowType.Raw,
        key: 'raw',
        content: <RatingsByVenueTable {...tableProps} />,
      },
    ],
    [tableProps],
  );

  return (
    <SummaryTable
      onRetry={ratingsByVenueInsights.refetch}
      isError={
        ratingsByVenueInsights.isError || (ratingsByVenueInsights.isLoading && !ratingsByVenueInsights.isFetching)
      }
      isFetching={ratingsByVenueInsights.isRefetching}
      title={intl.formatMessage({ id: 'insights.ratings-and-reviews.ratings-by-venue-table-title' })}
      rows={rows}
    />
  );
};
